import { render, staticRenderFns } from "./disputes-list-v2.vue?vue&type=template&id=4c339cec"
import script from "./disputes-list-v2.vue?vue&type=script&lang=js"
export * from "./disputes-list-v2.vue?vue&type=script&lang=js"
import style0 from "./disputes-list-v2.vue?vue&type=style&index=0&id=4c339cec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports